module.exports = __webpack_public_path__ + "img/the-craftenstock-corporation.65388536.jpg";